import { GET_PERMISSIONS, GET_PERMISSIONS_SUCCESS, GET_PERMISSIONS_FAILURE } from './constants';

export const getPermissions = (payload?: any) => ({ type: GET_PERMISSIONS, payload });
export const getPermissionsSuccess = payload => ({ type: GET_PERMISSIONS_SUCCESS, payload });
export const getPermissionsError = error => ({ type: GET_PERMISSIONS_FAILURE, error });
